import { render } from "./modal_viewitemsdetails.vue?vue&type=template&id=12664196&scoped=true"
import script from "./modal_viewitemsdetails.vue?vue&type=script&lang=js"
export * from "./modal_viewitemsdetails.vue?vue&type=script&lang=js"

import "./modal_viewitemsdetails.vue?vue&type=style&index=0&id=12664196&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12664196"]])

export default __exports__